"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Accordion-Widget.
 *
 * @class
 * @extents gc.gis.widget.GCWidget
 * @memberof gc.gis.widget
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 */
gc.gis.widget.GCAccordion = function(options)
{
    gc.gis.widget.GCWidget.call(this, options);

    /**
     * Liste der Einträge.
     * @type {jQuery[]}
     * @private
     */
    this._items = [];
    /**
     * Liste Options der Einträge, enthält z.B. die Event-Hanlder für Öffnen/Schließen etc.
     * @type {Object[]}
     * @private
     */
    this._itemsOptions = [];
};
gc.gis.widget.GCAccordion.prototype = Object.create( gc.gis.widget.GCWidget.prototype );

/**
 * @inheritdoc
 */
gc.gis.widget.GCAccordion.prototype._render = function()
{
    // Container
    if(!this.element)
    {
        this.element = jQuery('<div>', {
            'class': 'gc-widget-accordion panel-group'
            + (this.className ? ' ' + this.className : '')
        });
        if( this.id )
        {
            this.element.attr('id', this.id);
        }
    }
    else
    {
        this.clear();
    }

    return this.element;
};

/**
 * Leert den Container.
 *
 * @method
 * @public
 */
gc.gis.widget.GCAccordion.prototype.clear = function()
{
    if(this.element)
    {
        this.element.children().remove();
        this._items = [];
    }
};

/**
 * Liefert die Anzahl der Elemente des Containers.
 *
 * @method
 * @return {int}
 * @public
 */
gc.gis.widget.GCAccordion.prototype.numItems = function()
{
    return this._items.length;
};

/**
 * Liefert das Element zum Eintrag am angegeben Index.
 *
 * @method
 * @param {int} index Index des abgefragten Eintrags
 * @return {jQuery|null} Item-Element
 * @public
 */
gc.gis.widget.GCAccordion.prototype.getItem = function(index)
{
    if (index >= 0 && index < this._items.length)
    {
        return this._items[index];
    }

    return null;
};

/**
 * Liefert ein Flag, welches anzeigt, ob das Element zum Eintrag am angegeben Index geöffnet ist.
 *
 * @method
 * @param {int} index Index des abgefragten Eintrags
 * @return {boolean}
 * @public
 */
gc.gis.widget.GCAccordion.prototype.isItemOpen = function(index)
{
    var item = this.getItem(index);
    if (item)
    {
        item = item.find('.panel-heading .panel-titel');
        if (item) {
            return item.attr('aria-expanded') === 'true';
        }
    }

    return false;
};

/**
 * Öffnet das Element zum Eintrag am angegeben Index.
 *
 * @method
 * @param {int} index Index des zu öffnenden Eintrags
 * @return {boolean}
 * @public
 */
gc.gis.widget.GCAccordion.prototype.openItem = function(index)
{
    var self = this;
    var item = this.getItem(index);

    if (item)
    {
        item.find('.panel-collapse').collapse('show');
        item.find('.panel-heading .caret').addClass('in');

        if (this._itemsOptions[index].open && typeof this._itemsOptions[index].open == 'function')
        {
            this._itemsOptions[index].open.call(self, index, {});
        }

        return true;
    }

    return false;
};

/**
 * Schließt das Element zum Eintrag am angegeben Index.
 *
 * @method
 * @param {int} index Index des zu schließenden Eintrags
 * @return {boolean}
 * @public
 */
gc.gis.widget.GCAccordion.prototype.closeItem = function(index)
{
    var self = this;
    var item = this.getItem(index);

    if (item)
    {
        item.find('.panel-collapse').collapse('hide');
        item.find('.panel-heading .caret').removeClass('in');

        if (this._itemsOptions[index].close && typeof this._itemsOptions[index].close == 'function')
        {
            this._itemsOptions[index].close.call(self, index, {});
        }

        return true;
    }

    return false;
};

/**
 * Fügt ein Eintrag dem Container hinzu.
 *
 * @method
 * @param {string} id
 * @param {string} label
 * @param {string} content
 * @param {Object} [opt_options] optionale Optionen
 * @param {string} [opt_options.badge] Badge anzeigen
 * @param {boolean} [opt_options.collapsed] Flag, ob der Eintrag initial aufgeklappt werden soll
 * @param {function} [opt_options.open] Callback, die beim Aufklappen eines Items aufgerufen wird
 * @param {function} [opt_options.close] Callback, die beim Schließen eines Items aufgerufen wird
 * @param {function} [opt_options.enter] Callback, die beim Betreten des Items mit der Maus aufgerufen wird
 * @param {function} [opt_options.leave] Callback, die beim Verlassen des Items mit der Maus aufgerufen wird
 * @return {jQuery}
 * @public
 */
gc.gis.widget.GCAccordion.prototype.addItem = function(id, label, content, opt_options)
{
    opt_options = opt_options || {};

    var self = this;
    var collapsed = opt_options.collapsed || false;
    var badge = opt_options.badge || '';
    badge = badge.toString();

    var panel = jQuery('<div>', {
        'class': 'panel panel-default'
    });
    var panel_head = jQuery('<div>', {
        'class': 'panel-heading gc-collapseble-area'
    });
    var headline = '<span class="caret' + (collapsed ? ' in' : '') + '"></span>' + label;
    if (badge.length > 0) {
        headline += '<span class="badge">' + badge + '</span>';
    }
    var panel_headline = jQuery('<h4>', {
        'class': 'panel-titel',
        'data-toggle': 'collapse',
        'data-target': '#' + id,
        'aria-expanded': collapsed,
        'html': headline
    });
    var panel_collapse = jQuery('<div>', {
        'id': id,
        'class': 'panel-collapse collapse' + (collapsed ? ' in' : '')
    });
    var panel_body = jQuery('<div>', {
        'class': 'panel-body',
        'html': content
    });

    panel_head.append(panel_headline);
    panel_collapse.append(panel_body);
    panel.append(panel_head).append(panel_collapse);
    this.getElement().append(panel);

    var length = this._items.push(panel);
    this._itemsOptions.push(opt_options);

    panel_headline.click(function(evt) {
        panel_headline.children('.caret').toggleClass('in');
        var open = panel_headline.children('.caret').hasClass('in');

        if (open && opt_options.open && typeof opt_options.open == 'function')
        {
            opt_options.open.call(self, length-1, evt);
        }

        if (!open && opt_options.close && typeof opt_options.close == 'function')
        {
            opt_options.close.call(self, length-1, evt);
        }
    });

    if (opt_options.enter && typeof opt_options.enter == 'function') {
        panel.mouseenter(function (evt) {
            opt_options.enter.call(self, length-1, evt);
        });
    }

    if (opt_options.leave && typeof opt_options.leave == 'function') {
        panel.mouseleave(function (evt) {
            opt_options.leave.call(self, length-1, evt);
        });
    }

    return panel;
};

/**
 * Setzt den Inhalt eines Eintrags zum angegeben Index.
 *
 * @method
 * @param {int} index Index des Eintrags
 * @param {jQuery|string} content Inhalt
 * @public
 */
gc.gis.widget.GCAccordion.prototype.setItemContent = function(index, content)
{
    var item = this.getItem(index);
    if (item)
    {
        if (content instanceof jQuery) {
            item.find('.panel-body').append(content);
        }
        else {
            item.find('.panel-body').html(content);
        }
    }
};

/**
 * Setzt den Badge-Inhalt zu einem Eintrag zum angegeben Index.
 *
 * @method
 * @param {int} index Index des Eintrags
 * @param {string} badge neuer Badge-Inhalt
 * @public
 */
gc.gis.widget.GCAccordion.prototype.setItemBadge = function(index, badge)
{
    var item = this.getItem(index);
    if (item)
    {
        var badge_element = item.find('.badge');
        if (badge_element) {
            badge_element.html(badge);
        }
    }
};